export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

async function parseErrorMessage(response: Response): Promise<string> {
  try {
    const data = await response.json();
    if (typeof data?.error === 'string') return data.error;
    if (typeof data?.message === 'string') return data.message;
  } catch {
    // ignore JSON parse errors
  }
  return 'Network response was not ok';
}

// Fetcher for SWR
export const fetcher = async (url: string) => {
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  });
  if (!response.ok) {
    const message = await parseErrorMessage(response);
    throw new ApiError(message, response.status);
  }
  return response.json();
};

export async function parseApiError(response: Response, fallback: string): Promise<Error> {
  if (response.ok) {
    return new Error(fallback);
  }
  const message = await parseErrorMessage(response);
  return new Error(message || fallback);
}
